import AppTooltip from './components/tootltip';
import AppDataImage from './components/dataImage';
import AppSidebar from './components/sidebar';
import AppTable from './components/table';
import AppGeocode from './components/geocode';
import AppMapCluster from './components/mapCluster';
import AppConfirmed from './components/confirmed';
import AppCalendar from './components/calendar';
import AppDropzone from './components/dropzone';
import AppCodeHighlight from "./components/codeHighlight";
import AppAsyncImage from "./components/asyncImage";
import AppMediaFlag from "./components/mediaFlag";
import AppCart from "./components/cart";
import AppMediaModal from "./components/mediaModal";
import AppClipboard from "./components/clipboard";
import AppCustomerFilter from "./components/customerFilter";

(function() {
    function isGoogleFont(element) {
        return (
            element.tagName === 'LINK'
            && element.getAttribute('type') === 'text/css'
            && typeof element.href === 'string'
            && element.href.indexOf('https://fonts.googleapis.com/css') === 0
        );
    }

    let head = document.getElementsByTagName('head')[0];

    let insertBefore = head.insertBefore;
    head.insertBefore = function (newElement, referenceElement) {
        if (!isGoogleFont(newElement)) {
            insertBefore.call(head, newElement, referenceElement);
        }
    };
})();

$(window).on('load', function() {
    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });

    Handlebars.registerHelper('math', function(v1, operator, v2, options) {
        if(v1 === null) {
            v1 = 0;
        }
        v1 = parseFloat(v1);
        v2 = parseFloat(v2);

        switch (operator) {
            case '+':
                return v1 + v2;
            case '-':
                return v1 - v2;
            case '*':
                return v1 * v2;
            case '/':
                return v1 / v2;
        }
    });

    Handlebars.registerHelper('ifIn', function(elem, list, options) {
        if(list.indexOf(elem) > -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    $.ajaxSetup({
        cache: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        }
    });

    window.app = {};

    window.app.tooltip = new AppTooltip;
    window.app.dataImage = new AppDataImage;
    window.app.sidebar = new AppSidebar;
    window.app.table = new AppTable;
    window.app.geocode = new AppGeocode;
    window.app.mapCluster = new AppMapCluster;
    window.app.confirmed = new AppConfirmed;
    window.app.calendar = new AppCalendar;
    window.app.dropzone = new AppDropzone;
    window.app.codeHighlight = new AppCodeHighlight;
    window.app.asyncImage = new AppAsyncImage;
    window.app.mediaFlag = new AppMediaFlag;
    window.app.cart = new AppCart;
    window.app.mediaModal = new AppMediaModal;
    window.app.clipboard = new AppClipboard;
    window.app.customerFilter = new AppCustomerFilter;
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js